import * as React from 'react';

import {Link} from 'shells/link/link';

import {ViewUrlsModal} from './view-urls-modal';

type Props = {
    isDisabled: boolean;
    formUrls: string[];
};

export function ViewFormButton(props: Props) {
    const [isViewingUrlsModal, setIsViewingUrlsModal] = React.useState<boolean>(false);
    const singleFormUrl =
        props.formUrls && props.formUrls.length === 1 ? props.formUrls[0] : undefined;

    const tag = singleFormUrl ? 'a' : 'button';

    return (
        <>
            <Link
                as={tag}
                // @ts-expect-error
                disabled={props.isDisabled}
                variant='button-secondary'
                size='big'
                newTab={true}
                href={singleFormUrl}
                onClick={() => {
                    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                    singleFormUrl ? undefined : setIsViewingUrlsModal(true);
                }}
            >
                View form
            </Link>
            {isViewingUrlsModal && props.formUrls.length ? (
                <ViewUrlsModal
                    formUrls={props.formUrls}
                    onClose={() => setIsViewingUrlsModal(false)}
                />
            ) : undefined}
        </>
    );
}
